module.exports = __webpack_public_path__ + "img/Dinamo50x182.5139ab41.png";